import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './CuratorHeader.css';
import React from 'react';
import { get, getGlobalDictionaryTerm, getPageThemeColors, canUseDOM, getColorByTheme } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';

//ressources
import { ReactComponent as IconTwitter } from '../../resources/icons/twitter.svg';
import { ReactComponent as IconInsta } from '../../resources/icons/InstagramBlue.svg';
import { ReactComponent as IconFacebook } from '../../resources/icons/facebook.svg';
import { ReactComponent as IconYoutube } from '../../resources/icons/youtube.svg';
import { ReactComponent as IconLinkedin } from '../../resources/icons/linkedin.svg';
import { Text, RichText, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var videoWhiteOverlayTime = 750;
var videoFadeTime = 400;
export var CuratorHeader = function CuratorHeader(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  var introText = get(fields, 'data.item.introText.jss');
  var curatorName = get(fields, 'data.item.curatorName.jss') || {};
  var name = get(fields, 'data.item.name');
  var facebookHREF = get(fields, 'data.item.facebook.jss.value', '');
  var instaHREF = get(fields, 'data.item.instagram.jss.value', '');
  var twitterHREF = get(fields, 'data.item.twitter.jss.value', '');
  var youtubeHREF = get(fields, 'data.item.youtube.jss.value', '');
  var linkedinHREF = get(fields, 'data.item.linkedIn.jss.value', '');
  var curatorRole = get(fields, 'data.item.curatorRole.jss');
  var socialAnalytics = fields.data.socialAnalytics;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var ColorHex = get(params, 'ColorHex');
  var variables = BackgroundColorHex ? {
    '--m57-curator-header-primary-color': BackgroundColorHex,
    '--m57-curator-header-active-primary-color': ActiveColorHex,
    '--m57-curator-header-color': ColorHex
  } : {
    '--m57-curator-header-primary-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--m57-curator-header-active-primary-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m57-curator-header-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    "data-animation-breakpoint": "768",
    className: "header-animation-breakpoint header__poi header__full-width-mob js-header-bm-parent"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder(), /*#__PURE__*/React.createElement("div", {
    className: "header-bb__info js-header-bm header-animation__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-animate__content-bg"
  }), /*#__PURE__*/React.createElement("div", {
    className: "header__type-tag"
  }, /*#__PURE__*/React.createElement(Text, {
    field: curatorRole
  })), curatorName.value ? /*#__PURE__*/React.createElement("h1", {
    className: "header__info-title"
  }, /*#__PURE__*/React.createElement(Text, {
    field: curatorName
  })) : '', (facebookHREF || instaHREF || twitterHREF || youtubeHREF || linkedinHREF) && /*#__PURE__*/React.createElement("div", {
    className: "header__icons"
  }, facebookHREF && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: facebookHREF,
    "aria-label": "Facebook",
    rel: "noopener noreferrer",
    title: "Facebook: ".concat(curatorName.value, " | ").concat(newWindowLabel),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), "Facebook : ".concat(name));
    }
  }, /*#__PURE__*/React.createElement(IconFacebook, {
    className: "details-icon__img"
  })), instaHREF && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: instaHREF,
    "aria-label": "Instagram",
    rel: "noopener noreferrer",
    title: "Instagram: ".concat(curatorName.value, " | ").concat(newWindowLabel),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), "Instagram : ".concat(name));
    }
  }, /*#__PURE__*/React.createElement(IconInsta, {
    className: "details-icon__img"
  })), twitterHREF && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: twitterHREF,
    "aria-label": "Twitter",
    rel: "noopener noreferrer",
    title: "Twitter: ".concat(curatorName.value, " | ").concat(newWindowLabel),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), "Twitter : ".concat(name));
    }
  }, /*#__PURE__*/React.createElement(IconTwitter, {
    className: "details-icon__img"
  })), youtubeHREF && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: youtubeHREF,
    "aria-label": "Youtube",
    rel: "noopener noreferrer",
    title: "Youtube: ".concat(curatorName.value, " | ").concat(newWindowLabel),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), "Youtube : ".concat(name));
    }
  }, /*#__PURE__*/React.createElement(IconYoutube, {
    className: "details-icon__img"
  })), linkedinHREF && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: linkedinHREF,
    "aria-label": "Linkedin",
    rel: "noopener noreferrer",
    title: "Linkedin: ".concat(curatorName.value, " | ").concat(newWindowLabel),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), "Linkedin : ".concat(name));
    }
  }, /*#__PURE__*/React.createElement(IconLinkedin, {
    className: "details-icon__img"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "header__content-p"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: introText
  })))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "header-animation ".concat(commonStyle, "  ").concat(fullWidthStyles, "  ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(headerImageStyle)
  }, children);
};
var commonStyle = "c10pwjl7";
var ltrStyles = "l1l6wt9c";
var rtlStyles = "r17pw6z8";
export default CuratorHeader;